import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { DOCUMENT } from '@angular/common';
import { GenesysCloudConfigService } from 'common/genesys-cloud-config';

@Component({
  selector: 'app-permission-denied',
  templateUrl: './permission-denied.component.html',
  styleUrls: ['./permission-denied.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PermissionDeniedComponent {

  readonly purecloudUri$ = this.genesysCloudConfigService.apiEndpoints$.pipe(
    map((apiEndpoints) => apiEndpoints.purecloudUri));

  constructor(@Inject(DOCUMENT) private document: Document,
              private readonly genesysCloudConfigService: GenesysCloudConfigService){
  }

  navigate(url: string) {
      this.document.location.replace(url);
  }
}
